import * as THREE from "three";
import { Context } from "../core/context";

import {
  DrawOperationMovePointBeforeParams,
  DrawOperationMovePointParams,
  IModifyOperation,
  ModifyOperateState,
} from "./IModifyOperation";

import {
  CommonColor,
  LoopAnnotationModifyAcceptParams,
  LoopAnnotationModifyReturnData,
  SampleLayerType,
} from "@/core/Parameters";
import { TextModel } from "@/core/TextModel";
import { DbLine } from "@/core/DbLine";
import { ULabel } from "@/ui/ULabel";

class LoopAnnotationModify implements IModifyOperation {
  private m_context: Context;
  private m_curPoint: THREE.Vector3 = new THREE.Vector3();
  private m_locationObject: THREE.Line;
  private m_auxLineGroupCurrent: THREE.Group = new THREE.Group();
  private m_currentAuxEdgeLine: THREE.Line | undefined;
  private m_currentSignLine: THREE.Line | undefined;
  private m_returnData: LoopAnnotationModifyReturnData[] = [];
  private m_points: THREE.Vector3[] = [];
  private m_textModel: TextModel;
  private m_curTextModel: THREE.Mesh | undefined;
  private m_curText: string = "";
  private m_curTextNumber: string = "";
  private m_select!: DbLine;
  private m_acceptParams: LoopAnnotationModifyAcceptParams;
  private m_textSize: number = 0.35;
  private m_auxEdgeLinePositions: THREE.Vector3[] = [];
  private m_TextLabel: ULabel;
  private m_isShift: Boolean = false;

  constructor(
    context: Context,
    acceptParams: LoopAnnotationModifyAcceptParams
  ) {
    this.m_context = context;
    this.m_locationObject = context.ToolsManager.CreatedLocationLine();
    this.m_context.SceneManager.AuxModel.add(this.m_auxLineGroupCurrent);
    this.m_textModel = new TextModel(this.m_context);
    this.m_acceptParams = acceptParams;
    this.m_TextLabel = new ULabel(
      this.m_context.ViewManager,
      this.m_context.Dom
    );
    this.m_TextLabel.Visibility = true;
    this.m_curTextNumber = this.m_acceptParams.number;
  }

  OnMovePointBefore(params: DrawOperationMovePointBeforeParams): void {}
  OnMovePoint(point: DrawOperationMovePointParams): void {
    this.m_curPoint = point.point;
    this.m_locationObject.position.copy(this.m_curPoint);
    let TextLabelLocation = new THREE.Vector3();
    TextLabelLocation.x = this.m_curPoint.x + this.Scale * 30;
    TextLabelLocation.y = this.m_curPoint.y - this.Scale * 10;
    this.m_TextLabel.SetVaule(
      "长按Shift锁定正交",
      TextLabelLocation,
      new THREE.Vector3(1, 0, 0)
    );
    if (this.m_points.length == 1) {
      if (this.m_isShift) {
        this.m_curPoint = this.m_context.ToolsManager.GetOrthogonalityPoint(
          this.m_curPoint,
          this.m_points[this.m_points.length - 1]
        );
      }
      this.updateTempObject();
    }
  }
  OnDownPoint(point: DrawOperationMovePointParams): void {
    let { obejct } = point;
    if (this.m_returnData.length == 1 && !this.m_acceptParams.isContinuous) {
      return;
    }
    if (this.m_points.length) {
      let currentData = this.getCurrentData();
      this.m_returnData.push(currentData);
      this.m_points.length = 0;
      this.m_acceptParams.callbackUnderway(point.point.clone());
      return;
    }
    if (obejct?.length) {
      if (this.m_points.length) return;
      let obj = obejct[0] as DbLine;
      let layerName = this.m_context.ModelManager.GetLayerById(
        obj.layerId
      )?.Name;
      if (layerName) {
        let sampleData =
          this.m_context.ModelManager.GetSampleDataByLayerName(layerName);
        if (
          sampleData &&
          this.m_acceptParams.accordLayerNames.includes(sampleData?.LayerName)
        ) {
          this.m_select = obj;
          this.m_points.push(this.m_curPoint.clone());
          this.createTempLine();
          this.m_currentSignLine?.position.copy(point.point);
          this.m_curText = this.m_acceptParams.text;
          if (this.m_curTextNumber) {
            this.m_curText += this.m_curTextNumber;
          }

          this.m_curTextModel = this.m_textModel.CreateText({
            text: this.m_curText,
            size: this.m_textSize,
          });
          if (this.m_acceptParams.isNumberContinuous) {
            if (this.m_curTextNumber) {
              this.m_curTextNumber = (
                Number(this.m_curTextNumber) + 1
              ).toString();
            }
          }
          this.m_curTextModel.visible = false;
          this.m_auxLineGroupCurrent.add(this.m_curTextModel);
        }
      }
    }
  }
  onKeyDown(e: KeyboardEvent): void {
    if (e.keyCode == 16) {
      this.m_isShift = true;
    }
  }
  onKeyUp(e: KeyboardEvent): void {
    if (e.keyCode == 16) {
      this.m_isShift = false;
    }
  }

  OnZoom(camera: THREE.Camera): void {}

  Finish(operate: ModifyOperateState) {
    this.clear();
    if (operate == ModifyOperateState.complete) {
      return this.m_returnData;
    } else if (operate == ModifyOperateState.cancel) {
      return [];
    }
  }
  OnWheel(e: WheelEvent): void {}

  onMouseMove(e?: PointerEvent): void {}

  onMouseDown(e: PointerEvent): void {}

  onMouseUp(e: PointerEvent): void {}
  private get CurDir() {
    return this.m_curPoint.clone().sub(this.m_points[0]);
  }
  private get Scale() {
    return this.m_context.ViewManager.ScreenModelScale;
  }

  private createTempLine() {
    let geo = new THREE.BufferGeometry();
    geo.setFromPoints([
      new THREE.Vector3(-0.175, 0, 0),
      new THREE.Vector3(0.175, 0, 0),
    ]);
    let mat = new THREE.LineBasicMaterial();
    this.m_currentAuxEdgeLine = new THREE.Line(new THREE.BufferGeometry(), mat);
    this.m_currentSignLine = new THREE.Line(geo, mat);
    this.m_currentAuxEdgeLine.frustumCulled = false;
    this.m_currentSignLine.frustumCulled = false;
    this.m_currentSignLine.rotation.z = (Math.PI / 4) * 3;
    this.m_auxLineGroupCurrent.add(
      this.m_currentAuxEdgeLine,
      this.m_currentSignLine
    );
  }

  private updateTempObject() {
    if (this.m_points.length && this.m_curTextModel) {
      this.m_curTextModel.visible = true;
      let xAxis = new THREE.Vector3(1, 0, 0);
      let textLength =
        this.m_curTextModel.geometry.boundingBox!.max.x -
        this.m_curTextModel.geometry.boundingBox!.min.x;
      let auxEndPointDir = xAxis.clone().setLength(textLength + 0.2);
      let auxStartPoint = this.m_points[0];
      let auxEndPoint = this.m_curPoint.clone().add(auxEndPointDir);

      let ps = this.m_select.V3Points!;
      let selectV = ps[1].clone().sub(ps[0]).normalize();
      let selectRadian = selectV.angleTo(xAxis);
      if (selectV.clone().cross(xAxis).z > 0) {
        selectRadian = Math.PI - selectRadian;
      }
      let curLockSelectRadian = this.CurDir.angleTo(selectV);
      let curLockXAxisRadian = this.CurDir.angleTo(xAxis);

      if (this.CurDir.clone().cross(selectV).z > 0) {
        curLockSelectRadian = Math.PI * 2 - curLockSelectRadian;
      }
      let currentSignLineRotateRadian = (Math.PI / 4) * 3 + selectRadian;
      if (
        (curLockSelectRadian > Math.PI / 2 && curLockSelectRadian < Math.PI) ||
        (curLockSelectRadian > (Math.PI / 2) * 3 &&
          curLockSelectRadian < Math.PI * 2)
      ) {
        currentSignLineRotateRadian = Math.PI / 4 + selectRadian;
      }
      if (
        curLockXAxisRadian > Math.PI / 2 &&
        curLockXAxisRadian < (Math.PI / 2) * 3
      ) {
        auxEndPoint = this.m_curPoint
          .clone()
          .add(auxEndPointDir.clone().negate());
      }

      let dir = new THREE.Vector3(0, this.m_textSize / 2 + 0.05, 0);
      let cP = new THREE.Vector3()
        .lerpVectors(this.m_curPoint, auxEndPoint, 0.5)
        .add(dir);
      this.m_curTextModel.position.copy(cP);
      this.m_auxEdgeLinePositions = [
        auxStartPoint,
        this.m_curPoint,
        auxEndPoint,
      ];
      this.m_currentSignLine!.rotation.z = currentSignLineRotateRadian;
      this.m_currentAuxEdgeLine?.geometry.setFromPoints(
        this.m_auxEdgeLinePositions
      );
    }
  }

  private getCurrentData() {
    let signMatrix = new THREE.Matrix4();
    let q = new THREE.Quaternion().setFromAxisAngle(
      new THREE.Vector3(0, 0, 1),
      this.m_currentSignLine!.rotation.z
    );
    signMatrix.compose(
      this.m_currentSignLine!.position,
      q,
      new THREE.Vector3(1, 1, 1)
    );

    return {
      signMatrix,
      linePoints: this.m_auxEdgeLinePositions,
      textPosition: this.m_curTextModel!.position,
      extendId: this.m_select.extend_id!,
      text: this.m_curText,
    };
  }

  private clear() {
    this.m_context.ToolsManager.GroupClear(this.m_auxLineGroupCurrent);
    this.m_context.ToolsManager.ObjectsClear([this.m_locationObject]);
    this.m_TextLabel?.dispose();
  }
}

export { LoopAnnotationModify };
